<template>
  <div class="main__content">
    <div class="table__header_bar control-panel">
      <div>
        <InputSearch isFilter @detectSearchValue="searchTableHandler" />
      </div>
      <Button isControl iconName="plus" @click.native="createNews">
        {{ $t('sections.add_news') }}
      </Button>
    </div>
    <Table
      v-if="!!getContentAdminNewsTable"
      :content="getContentAdminNewsTable"
      @tableHandler="tableHandler"
    />
    <v-skeleton-loader v-else type="table" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Table from '@/elements/Table';
export default {
  components: {
    Table,
  },
  data() {
    return {};
  },

  created() {
    this.$store.dispatch('getNewsTableContentAdmin');
  },

  computed: {
    ...mapGetters(['getContentAdminNewsTable']),
  },
  methods: {
    createNews() {
      this.$router.push({
        name: 'content-administrator_create-news',
        params: { activity: 'create' },
      });
    },
    searchTableHandler(val) {
      this.$store.commit('SET_TABLE_SORT_DATA', { search: val });
      this.$store.dispatch('getNewsTableContentAdmin');
    },
    tableHandler() {
      this.$store.dispatch('getNewsTableContentAdmin');
    },
  },
};
</script>
